import { OrganizationRole } from '@moovit-sp-gmbh/hcloud-sdk/lib/interfaces/idp'

export function checkOrgRole(roleOfUser: OrganizationRole | undefined, requiredRole: OrganizationRole): boolean {
  if (!roleOfUser) {
    return false
  }

  switch (requiredRole) {
    case OrganizationRole.GUEST:
      return mayGuest(roleOfUser)
    case OrganizationRole.MEMBER:
      return mayRead(roleOfUser)
    case OrganizationRole.MANAGER:
      return mayManage(roleOfUser)
    case OrganizationRole.ADMIN:
      return mayAdmin(roleOfUser)
    case OrganizationRole.OWNER:
      return mayOwn(roleOfUser)
    default:
      return false
  }
}

function mayGuest(roleOfUser: OrganizationRole): boolean {
  return (
    roleOfUser === OrganizationRole.GUEST ||
    roleOfUser === OrganizationRole.MEMBER ||
    roleOfUser === OrganizationRole.MANAGER ||
    roleOfUser === OrganizationRole.ADMIN ||
    roleOfUser === OrganizationRole.OWNER
  )
}

function mayRead(roleOfUser: OrganizationRole): boolean {
  return (
    roleOfUser === OrganizationRole.MEMBER ||
    roleOfUser === OrganizationRole.MANAGER ||
    roleOfUser === OrganizationRole.ADMIN ||
    roleOfUser === OrganizationRole.OWNER
  )
}

function mayManage(roleOfUser: OrganizationRole): boolean {
  return (
    roleOfUser === OrganizationRole.MANAGER ||
    roleOfUser === OrganizationRole.ADMIN ||
    roleOfUser === OrganizationRole.OWNER
  )
}

function mayAdmin(roleOfUser: OrganizationRole): boolean {
  return roleOfUser === OrganizationRole.ADMIN || roleOfUser === OrganizationRole.OWNER
}

function mayOwn(roleOfUser: OrganizationRole): boolean {
  return roleOfUser === OrganizationRole.OWNER
}
